import { render, staticRenderFns } from "./TabDevoluciones.vue?vue&type=template&id=67d9b580&scoped=true"
import script from "./TabDevoluciones.vue?vue&type=script&lang=js"
export * from "./TabDevoluciones.vue?vue&type=script&lang=js"
import style0 from "./TabDevoluciones.vue?vue&type=style&index=0&id=67d9b580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d9b580",
  null
  
)

export default component.exports